import { CONTACTS } from '../store/constants';

export function getPhone() {
  const normalize = (phone: string) => phone.replace(/[^\d+]/g, '');
  const formatLink = (phone: string) => `tel:${normalize(phone)}`;

  return {
    PHONE: CONTACTS.PHONE,
    PHONE_NORMILIZE: formatLink(CONTACTS.PHONE),
  };
}
